import React, { useState } from "react";
import { Link } from "react-router-dom";
import NavLink from "../NavLink";
import logo from "../../logo-dark.svg";
import { routes } from "../../routes";
import UserMenu from "../UserMenu/UserMenu";
import MobileMenu from "./MobileMenu";

export default function MainNavBar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed inset-x-0 top-0 z-40 border-b border-mauve-800 bg-mauve-900 text-mauve-50">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <Link
          onClick={() => setIsOpen(false)}
          to={routes.home.path}
          className="inline-flex items-center"
        >
          <img src={logo} alt="faveback" className="h-10 w-auto" />
        </Link>

        <MobileMenu open={isOpen} onOpenChange={setIsOpen} />

        <div className="hidden items-center gap-6 md:flex">
          <NavLink
            to={routes.dashboard.path}
            className="nav-link text-sm text-mauve-200 transition hover:text-white"
            activeClassName="text-white"
          >
            Dashboard
          </NavLink>

          <UserMenu />
        </div>
      </div>
    </nav>
  );
}
